'use strict';

/**
 * Returns a new array with distinct elements from the input array.
 *
 * @template A - The type of elements in the array (string or number).
 * @param {A[]} arr - The input array.
 * @returns {A[]} - A new array with distinct elements.
 */ function distinctArray(arr) {
    return [
        ...new Set(arr)
    ];
}

module.exports = distinctArray;
